import { Helmet } from "react-helmet-async";
import { getRouteMeta, BASE_URL, OG_IMAGE } from "../data/seoRoutes";
import { company } from "../data/content";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: company.legalName,
  alternateName: company.brand,
  url: BASE_URL,
  logo: `${BASE_URL}/logo512.png`,
  slogan: company.slogan,
  description:
    "Trusted logistics and supply chain solutions provider offering freight forwarding, customs clearance, warehousing, and project logistics across Indonesia and international markets.",
  address: {
    "@type": "PostalAddress",
    addressCountry: company.addressCountry,
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: company.phone,
      contactType: "sales",
      email: company.emails.partnership,
      areaServed: "ID",
      availableLanguage: ["English", "Indonesian"],
    },
    {
      "@type": "ContactPoint",
      telephone: company.mobile,
      contactType: "customer service",
      email: company.emails.customerService,
      areaServed: "ID",
      availableLanguage: ["English", "Indonesian"],
    },
  ],
};

export default function Seo({ path, jsonLd }) {
  const meta = getRouteMeta(path);
  const canonical = `${BASE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content={company.brand} />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
